import React, { useState } from "react";
import "./Hazard_Detection.css";
import {
  Modal,
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  SelectChangeEvent,
  Drawer,
} from "@mui/material";
import { Link } from "react-router-dom";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material"
import DownloadIcon from "@mui/icons-material/Download";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import FormLabel from '@mui/material/FormLabel';


import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import ListItemIcon from '@mui/material/ListItemIcon'
import PersonAdd from '@mui/icons-material/PersonAdd';
import Tooltip from '@mui/material/Tooltip';
import Settings from '@mui/icons-material/Settings';
import Logout from '@mui/icons-material/Logout';
import MoreVertIcon from '@mui/icons-material/MoreVert';

import userImg from "../assets/ayush-chand.jpg";
import anchor from "antd/es/anchor";
import list from "antd/es/list";

import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';


type ChannelValue = "" | "channel01" | "channel02";
type Anchor = 'top' | 'left' | 'bottom' | 'right';
// tab start
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}
// tab end
function Hazard_Detection() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const [open, setOpen] = useState(false);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);

  // drawer start
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const toggleDrawer =
    (anchor: Anchor, open: boolean) =>
      (event: React.KeyboardEvent | React.MouseEvent) => {
        if (
          event.type === 'keydown' &&
          ((event as React.KeyboardEvent).key === 'Tab' ||
            (event as React.KeyboardEvent).key === 'Shift')
        ) {
          return;
        }

        setState({ ...state, [anchor]: open });
      };
  // drawer end

  // tab start
  const [value, setValue] = React.useState(0);

  const settingTabhandleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  // tab end


  const list = (anchor: Anchor) => (
    <Box className="drawer-box"
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 450 }}
      role="presentation"
      // onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <div className="d-flex items-center drawer-wrapper">
        <div className="drawer-wrapper-header">
          <h6>Settings</h6>
          <button onClick={toggleDrawer("right", false)}><i><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M405 136.798L375.202 107 256 226.202 136.798 107 107 136.798 226.202 256 107 375.202 136.798 405 256 285.798 375.202 405 405 375.202 285.798 256z"></path></svg></i></button>
        </div>
        <div className="drawer-wrapper-body">
          {/* tabstart */}
          <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs
                className="setting-tab"
                value={value}
                onChange={settingTabhandleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Image" />
                <Tab label="Video" />
                <Tab label="Live Stream" />

              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <Box className="detection-point-wrapper d-flex">
                <FormControl component="fieldset" variant="standard">
                  <FormLabel component="legend">Detection Point:</FormLabel>
                  <FormGroup>
                    <FormControlLabel control={<Checkbox defaultChecked />} label="Harness" />
                    <FormControlLabel control={<Checkbox />} label="PPE" />
                    <FormControlLabel control={<Checkbox />} label="Reverse Truck/Bus" />
                  </FormGroup>
                </FormControl>
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <Box className="detection-point-wrapper d-flex">
                <FormControl component="fieldset" variant="standard">
                  <FormLabel component="legend">Detection Point:</FormLabel>
                  <FormGroup>
                    <FormControlLabel control={<Checkbox defaultChecked />} label="Fire" />
                    <FormControlLabel control={<Checkbox />} label="Harness" />
                    <FormControlLabel control={<Checkbox />} label="PPE" />
                    <FormControlLabel control={<Checkbox />} label="Reverse Truck/Bus" />
                  </FormGroup>
                </FormControl>
              </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <Box className="detection-point-wrapper d-flex">
                <FormControl component="fieldset" variant="standard">
                  <FormLabel component="legend">Detection Point:</FormLabel>
                  <FormGroup>
                    <FormControlLabel control={<Checkbox defaultChecked />} label="Number Plate" />
                    <FormControlLabel control={<Checkbox />} label="Seat Belt" />
                    <FormControlLabel control={<Checkbox />} label="PPE" />
                    <FormControlLabel control={<Checkbox />} label="Reverse Truck/Bus" />
                  </FormGroup>
                </FormControl>
              </Box>
            </CustomTabPanel>

          </Box>
          {/* tabend */}







        </div>
        <div className="drawer-wrapper-footer">
          <button className="btn settingsave-btn" onClick={toggleDrawer("right", false)}>Save & Close</button>
        </div>
      </div>






    </Box>
  );


  const ExpandIcon = (
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M295.6 163.7c-5.1 5-5.1 13.3-.1 18.4l60.8 60.9H124.9c-7.1 0-12.9 5.8-12.9 13s5.8 13 12.9 13h231.3l-60.8 60.9c-5 5.1-4.9 13.3.1 18.4 5.1 5 13.2 5 18.3-.1l82.4-83c1.1-1.2 2-2.5 2.7-4.1.7-1.6 1-3.3 1-5 0-3.4-1.3-6.6-3.7-9.1l-82.4-83c-4.9-5.2-13.1-5.3-18.2-.3z"></path></svg>
  );

  const CollapseIcon = (
    <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 512 512" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M216.4 163.7c5.1 5 5.1 13.3.1 18.4L155.8 243h231.3c7.1 0 12.9 5.8 12.9 13s-5.8 13-12.9 13H155.8l60.8 60.9c5 5.1 4.9 13.3-.1 18.4-5.1 5-13.2 5-18.3-.1l-82.4-83c-1.1-1.2-2-2.5-2.7-4.1-.7-1.6-1-3.3-1-5 0-3.4 1.3-6.6 3.7-9.1l82.4-83c4.9-5.2 13.1-5.3 18.2-.3z"></path></svg>
  );

  const ExpandIcon1 = (
    <svg viewBox="64 64 896 896" focusable="false" data-icon="menu-unfold" width="100%" height="100%" fill="currentColor" aria-hidden="true"><path d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 000-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0014.4 7z"></path></svg>
  );

  const CollapseIcon1 = (
    <svg viewBox="64 64 896 896" focusable="false" data-icon="menu-fold" width="100%" height="100%" fill="currentColor" aria-hidden="true"><path d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 000 13.8z"></path></svg>
  );

  const SettingIcon = (
    <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>
  );

  const [activeMenu, setActiveMenu] = useState<"image" | "video" | "live">("image");

  const [channel, setChannel] = React.useState<ChannelValue>("");

  const handleChange = (event: SelectChangeEvent<ChannelValue>) => {
    setChannel(event.target.value as ChannelValue);
  };

  // Auto-collapse sidebar on window resize (below 768px)
  React.useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 992) {
        setSidebarCollapsed(true);
      } else {
        setSidebarCollapsed(false);
      }
    };
    // Run once on load
    handleResize();
    // Listen for window resizing
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // userprofile buttons start
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const opentip = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  // userprofile buttons end

  // file upload container collapse expand start
  const [isActive, setIsActive] = useState(true); // default active
  const [fileUploadCollapsed, setFileUploadCollapsed] = useState(false);

  const handleToggle = () => {
    setIsActive(!isActive);
    setFileUploadCollapsed(!fileUploadCollapsed);
  };
  //file upload container collapse expand end




  return (
    <div className="app-layout">
      {/* ================= SIDEBAR ================= */}
      <div className={`sidebar ${sidebarCollapsed ? "collapsed" : ""}`}>
        <div className="sidebar-header">
          <span className="sidebar-title">
            <Link to="/">
              <svg width="42" height="24" viewBox="0 0 109 60" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M103.473 8.02431C102.315 8.02431 101.32 7.64944 100.487 6.8997C99.6747 6.14994 99.2686 5.19758 99.2686 4.04256C99.2686 2.88754 99.6747 1.92503 100.487 1.15502C101.32 0.385005 102.315 0 103.473 0C104.671 0 105.686 0.385005 106.519 1.15502C107.352 1.92503 107.768 2.88754 107.768 4.04256C107.768 5.13677 107.352 6.07903 106.519 6.86931C105.686 7.63931 104.671 8.02431 103.473 8.02431ZM106.976 42.1581C106.976 44.1053 105.394 45.6838 103.442 45.6838C101.49 45.6838 99.9083 44.1053 99.9083 42.1581V18.0851C99.9083 16.1378 101.49 14.5593 103.442 14.5593C105.394 14.5593 106.976 16.1378 106.976 18.0851V42.1581Z" fill="white"></path><path d="M70.0538 40.0772C70.0388 40.053 70.0121 40.0378 69.9835 40.0378C69.9382 40.0378 69.9014 40.0746 69.9014 40.1199V56.2914C69.9014 58.3397 68.2371 60 66.1843 60C64.1314 60 62.467 58.3395 62.467 56.2914V15.7289C62.467 13.6806 64.1314 12.0202 66.1843 12.0202H67.0063C68.6052 12.0202 69.9014 13.3134 69.9014 14.9087V17.7159C69.9014 17.7607 69.9379 17.7971 69.9828 17.7971C70.0117 17.7971 70.0386 17.7814 70.0533 17.7564C72.5948 13.4188 76.304 11.25 81.181 11.25C85.3467 11.25 88.594 12.7156 90.9224 15.6468C93.2511 18.578 94.4153 22.5148 94.4153 27.4571C94.4153 32.9346 93.1015 37.3206 90.4738 40.6155C87.8462 43.9104 84.2573 45.558 79.7069 45.558C75.5348 45.558 72.3171 43.731 70.0538 40.0772ZM69.8373 27.072V31.1479C69.8373 33.5443 70.5956 35.5768 72.1124 37.2458C73.6506 38.9145 75.5946 39.7491 77.9445 39.7491C80.7003 39.7491 82.8579 38.6792 84.4176 36.5396C85.9983 34.3787 86.7887 31.3727 86.7887 27.5214C86.7887 24.2906 86.0518 21.7659 84.5777 19.9474C83.125 18.1073 81.1489 17.1873 78.6496 17.1873C76.0005 17.1873 73.8641 18.1287 72.2406 20.0115C70.6385 21.8944 69.8373 24.2479 69.8373 27.072Z" fill="white"></path><path d="M48.7936 43.1359C48.7911 43.0226 48.7434 42.9148 48.6599 42.8348C48.5765 42.7547 48.4639 42.7088 48.3459 42.7065L34.9975 42.7078C34.987 42.7078 34.9782 42.7022 34.9677 42.7022C34.9058 42.6986 34.8448 42.6881 34.7856 42.6707C34.7457 42.6634 34.7066 42.6533 34.6685 42.6399C34.613 42.6129 34.5612 42.5796 34.514 42.5404C34.4826 42.5205 34.4527 42.4986 34.4245 42.4746C34.3832 42.4283 34.3473 42.3776 34.3178 42.3236C34.2979 42.2942 34.2798 42.2636 34.2642 42.2319C34.259 42.2198 34.2447 42.2134 34.2432 42.1976L30.2474 30.8378C30.0444 30.1551 30.014 29.4356 30.1587 28.7394C30.3034 28.0431 30.6189 27.39 31.0792 26.8339L40.0409 16.0194C40.3062 15.6958 40.6462 15.4354 41.0339 15.2586C41.4216 15.0818 41.8467 14.9935 42.2761 15.0004L42.2804 15.0047L42.2849 15.0004L42.3007 15.004C42.6742 14.9995 43.0449 15.0668 43.3909 15.202C43.7369 15.3372 44.0511 15.5375 44.315 15.7911C44.392 15.8651 44.4646 15.9432 44.532 16.0252L53.4922 26.8369C53.9551 27.3983 54.271 28.0579 54.4136 28.7604C54.5563 29.463 54.5215 30.1881 54.3122 30.8751L52.4283 36.2316C52.3956 36.3266 52.3438 36.4146 52.2754 36.4903C52.2071 36.5661 52.1239 36.6281 52.0307 36.6728C51.9373 36.7176 51.8356 36.7442 51.7315 36.7511C51.6274 36.7581 51.5229 36.7451 51.4238 36.7131C51.325 36.681 51.2337 36.6306 51.1551 36.5646C51.0767 36.4986 51.0127 36.4183 50.9666 36.3285C50.9206 36.2387 50.8935 36.141 50.8871 36.0411C50.8805 35.9411 50.8948 35.841 50.9288 35.7463L52.8014 30.4236C52.9352 29.973 52.9553 29.4986 52.8598 29.0393C52.7645 28.5799 52.5565 28.149 52.253 27.7821L43.3018 16.9648C43.2372 16.8891 43.1633 16.8211 43.0818 16.7622V26.4604C44.0701 26.6486 44.9502 27.183 45.5506 27.9593C46.1511 28.7355 46.429 29.6983 46.3304 30.6602C46.2317 31.6221 45.7636 32.5146 45.0169 33.1637C44.2703 33.8128 43.2986 34.1724 42.291 34.1724C41.2833 34.1724 40.3117 33.8128 39.565 33.1637C38.8184 32.5146 38.3502 31.6221 38.2516 30.6602C38.1529 29.6983 38.4309 28.7355 39.0313 27.9593C39.6317 27.183 40.5118 26.6486 41.5002 26.4604L41.4994 16.7601C41.4182 16.82 41.3455 16.8898 41.2831 16.9676L32.3199 27.7764C32.019 28.1385 31.8116 28.5636 31.7148 29.0171C31.618 29.4707 31.6343 29.94 31.7627 30.3863L35.5675 41.1923L48.3489 41.1879C48.6154 41.1878 48.8793 41.2378 49.1255 41.3355C49.3716 41.4332 49.5955 41.5766 49.7838 41.7574C49.9723 41.9381 50.1217 42.1526 50.2235 42.3889C50.3254 42.6249 50.3776 42.8781 50.3774 43.1336L50.3782 46.7998C50.378 47.316 50.1641 47.811 49.7836 48.1761C49.403 48.5409 48.8872 48.7461 48.3489 48.7462L31.6699 48.7498C31.5648 48.7517 31.4605 48.7333 31.3628 48.696C31.2652 48.6587 31.1763 48.6032 31.1014 48.5325C31.0264 48.462 30.9668 48.3778 30.9262 48.2848C30.8854 48.1918 30.8644 48.0921 30.8644 47.9914C30.8644 47.8905 30.8852 47.7908 30.9258 47.6978C30.9664 47.6048 31.0258 47.5206 31.1008 47.4499C31.1758 47.3792 31.2645 47.3235 31.362 47.2862C31.4597 47.2487 31.564 47.2303 31.6691 47.232L48.3482 47.2313C48.407 47.2316 48.4654 47.2207 48.5199 47.1992C48.5743 47.1778 48.6239 47.1461 48.6654 47.1062C48.7071 47.0663 48.74 47.0188 48.7624 46.9667C48.7847 46.9144 48.7962 46.8585 48.7958 46.8019L48.7936 43.1359ZM40.546 31.9414C40.8911 32.2723 41.3308 32.4979 41.8095 32.5892C42.2881 32.6805 42.7845 32.6336 43.2353 32.4544C43.6864 32.2753 44.0718 31.9719 44.3428 31.5827C44.614 31.1933 44.7589 30.7358 44.7589 30.2676C44.7589 29.7994 44.614 29.3417 44.3428 28.9524C44.0718 28.563 43.6864 28.2596 43.2353 28.0806C42.7845 27.9013 42.2881 27.8544 41.8095 27.9458C41.3308 28.0371 40.8911 28.2626 40.546 28.5936C40.0837 29.0378 39.824 29.6398 39.824 30.2676C39.824 30.8951 40.0837 31.4972 40.546 31.9414Z" fill="white" stroke="white" stroke-width="0.9"></path><path d="M43.6885 8.42644C46.0207 8.42644 47.9114 6.54012 47.9114 4.21322C47.9114 1.88632 46.0207 0 43.6885 0C41.3562 0 39.4656 1.88632 39.4656 4.21322C39.4656 6.54012 41.3562 8.42644 43.6885 8.42644Z" fill="white"></path><path d="M26.3103 47.3462C26.3103 49.1571 24.839 50.625 23.024 50.625H3.75862C1.68279 50.625 0 48.9461 0 46.875V3.75C0 1.67893 1.68279 0 3.75862 0H4.12785C6.20368 0 7.88647 1.67893 7.88647 3.75V40.3174C7.88647 42.3883 9.56926 44.0674 11.6451 44.0674H23.024C24.839 44.0674 26.3103 45.5353 26.3103 47.3462Z" fill="white"></path></svg>
            </Link>
          </span>
        </div>
        <ul className="sidebar-menu">
          <li className="analysis-options">
            <span>Analysis Options:</span>
          </li>
          <li
            className={activeMenu === "image" ? "active" : ""}
            onClick={() => setActiveMenu("image")}
          >
            <span className="icon"><svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg></span>
            <span>Image Analysis</span>
          </li>
          <li
            className={activeMenu === "video" ? "active" : ""}
            onClick={() => setActiveMenu("video")}>
            <span className="icon"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12zM12 5.5v9l6-4.5z"></path></svg></span>
            <span>Video Analysis</span>
          </li>

          <li
            className={activeMenu === "live" ? "active" : ""}
            onClick={() => setActiveMenu("live")}
          >
            <span className="icon"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0V0z"></path><path d="M15 8v8H5V8h10m1-2H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4V7c0-.55-.45-1-1-1z"></path></svg></span>
            <span>Live Streaming</span>
          </li>

          {/* <li>
            <span className="icon"><svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline></svg></span>
            {!sidebarCollapsed && <span>Image Analysis</span>}
          </li> */}
        </ul>
        {/* ********* */}
        {/*  <div className="sidebarButton">
         <button
            className={`toggle-btn ${sidebarCollapsed ? "expand" : "collapsed"}`}
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}        >
            {sidebarCollapsed ? (
              <span className="icon-expand">
                {ExpandIcon}
              </span>
            ) : (
              <span className="icon-collapsed">
                {CollapseIcon}
              </span>
            )}
          </button> 
         
        </div>*/}

        <div className="settingButton">
          <button
            onClick={toggleDrawer("right", true)}
            className="toggle-btn">
            {sidebarCollapsed ? (
              <span>
                <i> {SettingIcon} </i>
              </span>
            ) : (
              <span >
                <i>{SettingIcon}</i> Settings
              </span>
            )}
          </button>

        </div>
        <div className="sidebarButton-btm">
          <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', textAlign: 'center' }}>
              <Tooltip title="Account settings">
                {sidebarCollapsed ? (
                  <IconButton
                    onClick={handleClick}
                    size="small"
                    aria-controls={opentip ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={opentip ? 'true' : undefined}
                  ><Typography className="avatar-wrapper">
                      <Avatar sx={{ width: 32, height: 32 }}> <img src={userImg} alt="" />  </Avatar>
                    </Typography>
                  </IconButton>
                ) : (

                  <IconButton
                    onClick={handleClick}
                    size="small"
                    aria-controls={opentip ? 'account-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={opentip ? 'true' : undefined}
                  ><Typography className="avatar-wrapper">
                      <Avatar sx={{ width: 32, height: 32 }}> <img src={userImg} alt="" />  </Avatar>
                      Ayush Chand</Typography>
                    <MoreVertIcon />
                  </IconButton>
                )}

              </Tooltip>
            </Box>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={opentip}
              onClose={handleClose}
              onClick={handleClose}
              style={{ borderRadius: "4px!important", border: "transparent" }}
              className="user-menu-btm"
              // slotProps={{
              //   paper: {
              //     elevation: 0,
              //     sx: {
              //       overflow: 'visible',
              //       filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              //       mt: 1.5,
              //       '& .MuiAvatar-root': {
              //         width: 32,
              //         height: 32,
              //         ml: -0.5,
              //         mr: 1,
              //       },           
              //     },
              //   },
              // }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >



              {/* <Divider /> */}
              {/* <MenuItem onClick={handleClose}>
          <ListItemIcon>
            <Settings fontSize="small" />
          </ListItemIcon>
          Settings
        </MenuItem> */}
              <MenuItem onClick={handleClose}>
                <ListItemIcon>
                  <Logout fontSize="small" />
                </ListItemIcon>
                Logout
              </MenuItem>
            </Menu>
          </React.Fragment>
        </div>

      </div>

      {/* ================= MAIN CONTENT ================= */}
      <div className="main-content">

        {/* Navbar */}
        <nav className="navbar navbar-expand-sm bg-dark navbar-dark navbar-header">
          <div className="container-fluid" style={{ justifyContent: "start", gap: "1rem" }}>
            <button
              className={`toggle-btn ${sidebarCollapsed ? "expand" : "collapsed"}`}
              onClick={() => setSidebarCollapsed(!sidebarCollapsed)} style={{ width: "32px", height: "32px", background: "transparent", padding: "6px" }}>
              {sidebarCollapsed ? (
                <span className="icon-expand" style={{ color: "#fff" }}>
                  {ExpandIcon1}
                </span>
              ) : (
                <span className="icon-collapsed" style={{ color: "#fff" }}>
                  {CollapseIcon1}
                </span>
              )}
            </button>
            <div className="d-flex align-items-center gap-2">
              <a className="brand text-white fw-bold hazard-detection-titleText">Hazard Detection</a>
            </div>
          </div>
        </nav>

        {/* Content */}
        <div className={`container-fluid hazard-bodyWrapper ${!isActive ? "active" : ""}`}>


          {activeMenu === "image" && (
            <div id="img-analysis">

              <div className={`analysis-column-wrapper ${isActive ? "active" : ""}`}>
                <div className={`file-upload-wrapper ${isActive ? "active-fileupload" : ""}`}>

                  <div className="upload-box">
                    <div className="upload-content text-center">
                      <div className="upload-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <h3 className="upload-title">Drop image file here or click to upload</h3>
                      <p className="upload-subtitle">Support for single or bulk uploads. Strictly PNG, JPG and GIF
                        files only.</p>
                      <button className="upload-button" type="button">Choose Files</button>
                      <input type="file" id="fileInput" multiple accept="image/*" hidden />
                    </div>
                  </div>

                  <div className="upload-file-wrapper">
                    <h6>Uploaded File</h6>
                    <div className="uploaded-file-row">
                      <span><i><svg stroke="currentColor" fill="none" stroke-width="1" viewBox="0 0 24 24"
                        stroke-linecap="round" stroke-linejoin="round" height="100%" width="100%"
                        xmlns="http://www.w3.org/2000/svg">
                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                        <circle cx="8.5" cy="8.5" r="1.5"></circle>
                        <polyline points="21 15 16 10 5 21"></polyline>
                      </svg></i> hazard-detecion.jpg</span>
                      <button className="trash-btn"><i><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M16 1.75V3h5.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H8V1.75C8 .784 8.784 0 9.75 0h4.5C15.216 0 16 .784 16 1.75Zm-6.5 0V3h5V1.75a.25.25 0 0 0-.25-.25h-4.5a.25.25 0 0 0-.25.25ZM4.997 6.178a.75.75 0 1 0-1.493.144L4.916 20.92a1.75 1.75 0 0 0 1.742 1.58h10.684a1.75 1.75 0 0 0 1.742-1.581l1.413-14.597a.75.75 0 0 0-1.494-.144l-1.412 14.596a.25.25 0 0 1-.249.226H6.658a.25.25 0 0 1-.249-.226L4.997 6.178Z"></path><path d="M9.206 7.501a.75.75 0 0 1 .793.705l.5 8.5A.75.75 0 1 1 9 16.794l-.5-8.5a.75.75 0 0 1 .705-.793Zm6.293.793A.75.75 0 1 0 14 8.206l-.5 8.5a.75.75 0 0 0 1.498.088l.5-8.5Z"></path></svg></i></button>
                    </div>
                  </div>

                  <div className="actionWrapper d-flex align-items-center">
                    <button className="btn analysis-btn" style={{ flexGrow: "1" }}>Analyze Image</button>
                  </div>

                </div>

                <div className="d-flex flex-column gap-3 pt-2 outputWrapper">
                  <button className="btn fileUploadToggle" onClick={handleToggle}>

                    {fileUploadCollapsed ? (
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm0 2h-9v14h9a1 1 0 0 0 .993 -.883l.007 -.117v-12a1 1 0 0 0 -.883 -.993l-.117 -.007zm-4.387 4.21l.094 .083l2 2a1 1 0 0 1 .083 1.32l-.083 .094l-2 2a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.292 -1.293l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083z"></path></svg>
                    ) : (
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm-3 2h-9a1 1 0 0 0 -.993 .883l-.007 .117v12a1 1 0 0 0 .883 .993l.117 .007h9v-14zm-3.293 4.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.292 1.293l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.32 .083l-.094 -.083l-2 -2a1 1 0 0 1 -.083 -1.32l.083 -.094l2 -2a1 1 0 0 1 1.414 0z"></path></svg>
                    )}

                  </button>
                  <div className="upload-filter">
                    <div className="d-flex align-items-center flex-grow-1" style={{ gap: "16px" }}>
                      {/* <div className="d-flex align-items-center">
                            <label
                                htmlFor="sel1"
                                className="form-label text-nowrap mb-0 pr-4"
                                style={{ marginRight: "8px", fontWeight: 600, color:"#f2f2f2" }}
                              >
                                Analysis Option
                              </label>
                                <select className="form-select" id="sel1" name="sellist1" style={{fontSize:"14px"}}>
                                    <option>Video</option>
                                    <option>Image</option>
                                    <option value="liveStream">Live Stream</option>
                                </select>
                        </div> */}
                      <h6 className="analysed-output" >Analysed Output</h6>

                    </div>
                    <div className="actionWrapper">

                      <button className="btn clear-btn" data-bs-toggle="modal" data-bs-target="#confirmationModal"><svg
                        stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24"
                        height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                        <path fill="none" d="M0 0h24v24H0V0z"></path>
                        <path
                          d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z">
                        </path>
                      </svg> Clear</button>
                    </div>
                  </div>
                  {/* Upload Section */}
                  <div className="upload-container">

                    <div className="upload-complete" id="uploadComplete">
                      <div className="video-output">Output</div>
                      <div className="video-render-container">
                        {/* <!-- img icon --> */}
                        <svg stroke="currentColor" fill="none" stroke-width="1" viewBox="0 0 24 24"
                          stroke-linecap="round" stroke-linejoin="round" height="144" width="144"
                          xmlns="http://www.w3.org/2000/svg">
                          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
                          <circle cx="8.5" cy="8.5" r="1.5"></circle>
                          <polyline points="21 15 16 10 5 21"></polyline>
                        </svg>

                        {/* <img src="construction-site-map.png" alt="" style="max-width: 100%; max-height: 100%; "> */}

                      </div>

                    </div>
                  </div>

                  {/* Data Table */}
                  <div className="data-container mt-0 mb-4">
                    <div className="card bg-dark text-white w-100">
                      <div className="card-header">
                        Identified Issues and Corrective Actions
                      </div>
                      <div className="card-body">
                        <table className="table table-dark table-hover">
                          <thead>
                            <tr>
                              <th>Identified Issue</th>
                              <th>Severity</th>
                              <th>Corrective Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Electrical Hazard</td>
                              <td>High</td>
                              <td>Inspect and fix unsafe wiring.</td>
                            </tr>
                            <tr>
                              <td>Trip Hazard</td>
                              <td>Medium</td>
                              <td>Remove loose materials from walkway.</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeMenu === "video" && (
            <div id="video-analysis">
              <div className={`analysis-column-wrapper ${isActive ? "active" : ""}`}>
                <div className={`file-upload-wrapper ${isActive ? "active-fileupload" : ""}`}>

                  <div className="upload-box">
                    <div className="upload-content text-center">
                      <div className="upload-icon">
                        <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M17 8l-5-5-5 5M12 3v12"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                            stroke-linejoin="round" />
                        </svg>
                      </div>
                      <h3 className="upload-title">Drop video file here or click to upload</h3>
                      <p className="upload-subtitle">Support for single uploads. Strictly .mp4, .mov files only.</p>
                      <button className="upload-button" type="button">Choose Files</button>
                      <input type="file" id="fileInput" multiple accept="image/*" hidden />
                    </div>
                  </div>

                  <div className="upload-file-wrapper">
                    <h6>Uploaded File</h6>
                    <div className="uploaded-file-row">
                      <span><i><svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg></i> hazard-detecion.mp4</span>
                      <button className="trash-btn"><i><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="100%" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M16 1.75V3h5.25a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1 0-1.5H8V1.75C8 .784 8.784 0 9.75 0h4.5C15.216 0 16 .784 16 1.75Zm-6.5 0V3h5V1.75a.25.25 0 0 0-.25-.25h-4.5a.25.25 0 0 0-.25.25ZM4.997 6.178a.75.75 0 1 0-1.493.144L4.916 20.92a1.75 1.75 0 0 0 1.742 1.58h10.684a1.75 1.75 0 0 0 1.742-1.581l1.413-14.597a.75.75 0 0 0-1.494-.144l-1.412 14.596a.25.25 0 0 1-.249.226H6.658a.25.25 0 0 1-.249-.226L4.997 6.178Z"></path><path d="M9.206 7.501a.75.75 0 0 1 .793.705l.5 8.5A.75.75 0 1 1 9 16.794l-.5-8.5a.75.75 0 0 1 .705-.793Zm6.293.793A.75.75 0 1 0 14 8.206l-.5 8.5a.75.75 0 0 0 1.498.088l.5-8.5Z"></path></svg></i></button>
                    </div>
                  </div>

                  <div className="actionWrapper d-flex align-items-center" style={{ gap: "8px" }}>
                    <button className="btn analysis-btn" style={{ flexGrow: "1" }}>Analyze Video</button>
                  </div>

                </div>

                <div className="d-flex flex-column gap-3 pt-2 outputWrapper">
                  <button className="btn fileUploadToggle" onClick={handleToggle}>

                    {fileUploadCollapsed ? (
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm0 2h-9v14h9a1 1 0 0 0 .993 -.883l.007 -.117v-12a1 1 0 0 0 -.883 -.993l-.117 -.007zm-4.387 4.21l.094 .083l2 2a1 1 0 0 1 .083 1.32l-.083 .094l-2 2a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.292 -1.293l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083z"></path></svg>
                    ) : (
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm-3 2h-9a1 1 0 0 0 -.993 .883l-.007 .117v12a1 1 0 0 0 .883 .993l.117 .007h9v-14zm-3.293 4.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.292 1.293l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.32 .083l-.094 -.083l-2 -2a1 1 0 0 1 -.083 -1.32l.083 -.094l2 -2a1 1 0 0 1 1.414 0z"></path></svg>
                    )}

                  </button>
                  <div className="upload-filter">
                    <div className="d-flex align-items-center flex-grow-1" style={{ gap: "16px" }}>
                      <h6 className="analysed-output">Analysed Output</h6>
                    </div>
                    <div className="actionWrapper">
                      <button className="btn clear-btn" data-bs-toggle="modal" data-bs-target="#confirmationModal"><svg
                        stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24"
                        height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                        <path fill="none" d="M0 0h24v24H0V0z"></path>
                        <path
                          d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z">
                        </path>
                      </svg> Clear</button>
                    </div>
                  </div>
                  {/* Upload Section */}
                  <div className="upload-container">
                    <div className="upload-complete" id="uploadComplete">
                      <div className="video-output">Output</div>
                      <div className="video-render-container">
                        <svg stroke="currentColor" fill="none" stroke-width="1" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="144" width="144" xmlns="http://www.w3.org/2000/svg"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg>
                        {/* <img src="construction-site-map.png" alt="" style="max-width: 100%; max-height: 100%; "> */}

                      </div>

                    </div>
                  </div>

                  {/* Data Table */}
                  <div className="data-container mt-0 mb-4">
                    <div className="card bg-dark text-white w-100">
                      <div className="card-header">
                        Identified Issues and Corrective Actions
                      </div>
                      <div className="card-body">
                        <table className="table table-dark table-hover">
                          <thead>
                            <tr>
                              <th>Identified Issue</th>
                              <th>Severity</th>
                              <th>Corrective Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Electrical Hazard</td>
                              <td>High</td>
                              <td>Inspect and fix unsafe wiring.</td>
                            </tr>
                            <tr>
                              <td>Trip Hazard</td>
                              <td>Medium</td>
                              <td>Remove loose materials from walkway.</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {activeMenu === "live" && (
            <div id="live-video-analysis">
              <div className={`analysis-column-wrapper ${isActive ? "active" : ""}`}>
                <div className={`file-upload-wrapper ${isActive ? "active-fileupload" : ""}`}>

                  <div className="live-streamurl-wrapper mb-2">
                    <div className="d-flex align-items-start flex-column flex-grow-1 " style={{ gap: "8px" }}>
                      <h6 className="live-video-label">Live video url:</h6>
                      <textarea className="form-control flex-grow-1 url-textbox" disabled id="url"
                        placeholder="https://www.youtube.com/embed/4BzjUq921Y4?autoplay=1&mute=1&rel=0&controls=0&modestbranding=1&iv_load_policy=3&playsinline=1&fs=0&cc_load_policy=0"
                        name="url" style={{ fontSize: "12px", height: "148px" }}></textarea>
                      {/* <select className="form-select slect-channel" id="sel1" name="sellist1">
                          <option value="">Select Channel</option>
                          <option>Channel 01</option>
                          <option>Channel 02</option>
                        </select> */}
                      <div className="channel-wrapper">
                        <FormControl fullWidth variant="outlined" size="small" style={{ width: "100%" }}>
                          <InputLabel id="channel-select-label">Select Channel</InputLabel>
                          <Select
                            labelId="channel-select-label"
                            id="sel1"
                            name="sellist1"
                            value={channel}
                            label="Select Channel"
                            onChange={handleChange}
                            className="chWrprSelect"
                          >
                            {/* Optional: disabled placeholder inside the list */}
                            <MenuItem value="">
                              None
                            </MenuItem>

                            <MenuItem value="channel01">Channel 01</MenuItem>
                            <MenuItem value="channel02">Channel 02</MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      {/* <Box className="detection-point-wrapper d-flex">
                        <FormControl component="fieldset" variant="standard">
                          <FormLabel component="legend">Detection Point:</FormLabel>
                          <FormGroup>
                            <FormControlLabel control={<Checkbox defaultChecked />} label="Harness" />
                            <FormControlLabel control={<Checkbox />} label="PPE" />
                            <FormControlLabel control={<Checkbox />} label="Reverse Truck/Bus" />
                          </FormGroup>
                        </FormControl>
                      </Box> */}
                    </div>
                  </div>
                  <div className="actionWrapper d-flex align-items-center" style={{ gap: "8px" }}>
                    <button className="btn analysis-btn" style={{ flexGrow: "1" }}>Analyze Video</button>
                  </div>
                </div>

                <div className="d-flex flex-column gap-3 pt-2 outputWrapper">
                  <button className="btn fileUploadToggle" onClick={handleToggle}>

                    {fileUploadCollapsed ? (
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm0 2h-9v14h9a1 1 0 0 0 .993 -.883l.007 -.117v-12a1 1 0 0 0 -.883 -.993l-.117 -.007zm-4.387 4.21l.094 .083l2 2a1 1 0 0 1 .083 1.32l-.083 .094l-2 2a1 1 0 0 1 -1.497 -1.32l.083 -.094l1.292 -1.293l-1.292 -1.293a1 1 0 0 1 -.083 -1.32l.083 -.094a1 1 0 0 1 1.32 -.083z"></path></svg>
                    ) : (
                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M18 3a3 3 0 0 1 2.995 2.824l.005 .176v12a3 3 0 0 1 -2.824 2.995l-.176 .005h-12a3 3 0 0 1 -2.995 -2.824l-.005 -.176v-12a3 3 0 0 1 2.824 -2.995l.176 -.005h12zm-3 2h-9a1 1 0 0 0 -.993 .883l-.007 .117v12a1 1 0 0 0 .883 .993l.117 .007h9v-14zm-3.293 4.293a1 1 0 0 1 .083 1.32l-.083 .094l-1.292 1.293l1.292 1.293a1 1 0 0 1 .083 1.32l-.083 .094a1 1 0 0 1 -1.32 .083l-.094 -.083l-2 -2a1 1 0 0 1 -.083 -1.32l.083 -.094l2 -2a1 1 0 0 1 1.414 0z"></path></svg>
                    )}

                  </button>
                  <div className="upload-filter">
                    <div className="d-flex align-items-center flex-grow-1" style={{ gap: "16px" }}>
                      <h6 className="analysed-output">Live Stream Analysation</h6>
                    </div>
                    <div className="actionWrapper">
                      <button className="btn clear-btn" data-bs-toggle="modal" data-bs-target="#confirmationModal"><svg
                        stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24"
                        height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                        <path fill="none" d="M0 0h24v24H0V0z"></path>
                        <path
                          d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z">
                        </path>
                      </svg> Clear</button>
                    </div>
                  </div>
                  {/* Upload Section */}
                  <div className="upload-container">
                    <div className="upload-complete" id="uploadComplete">
                      <div className="video-output">Output</div>
                      <div className="video-render-container">
                        {/* <!-- video icon --> */}
                        {/* <svg stroke="currentColor" fill="none" stroke-width="1" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="144" width="144" xmlns="http://www.w3.org/2000/svg"><polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect></svg> */}
                        {/*  */}
                        <iframe width="100%" height="100%" src="https://www.youtube.com/embed/4BzjUq921Y4?autoplay=1&mute=1&rel=0&controls=0&modestbranding=1&iv_load_policy=3&playsinline=1&fs=0&cc_load_policy=0" title="The Power and Beauty of Construction Sites: A Cinematic Reel" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;" ></iframe>
                      </div>

                    </div>
                  </div>

                  {/* Data Table */}
                  <div className="data-container mt-0 mb-4">
                    <div className="card bg-dark text-white w-100">
                      <div className="card-header">
                        Identified Issues and Corrective Actions
                      </div>
                      <div className="card-body">
                        <table className="table table-dark table-hover">
                          <thead>
                            <tr>
                              <th>Identified Issue</th>
                              <th>Severity</th>
                              <th>Corrective Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Electrical Hazard</td>
                              <td>High</td>
                              <td>Inspect and fix unsafe wiring.</td>
                            </tr>
                            <tr>
                              <td>Trip Hazard</td>
                              <td>Medium</td>
                              <td>Remove loose materials from walkway.</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

        </div>

        {/* Footer */}
        <div className="mapping-footer text-center text-white p-3">
          Copyright © 2025 Lipi. All Rights Reserved.

          <span className="poweredByonLogin">Powered by<svg height="24" viewBox="0 0 89 20" width="80" xmlns="http://www.w3.org/2000/svg"><title>Samvardhana Motherson</title><path d="M85.535 1.38a2.464 2.464 0 0 0-1.478 2.231v16.107h3.45c.817 0 1.479-.662 1.479-1.479V0zm-6.408 4.93a2.466 2.466 0 0 0-1.479 2.23v11.178h3.45a1.48 1.48 0 0 0 1.48-1.479V4.93zm-6.409 4.93a2.465 2.465 0 0 0-1.478 2.23v6.248h3.45c.817 0 1.479-.662 1.479-1.479V9.86zM.784 12.97h2.27v1.014c.356-.634 1.054-1.192 2.082-1.192.875 0 1.484.38 1.801 1.103.571-.774 1.358-1.103 2.195-1.103 1.256 0 2.17.811 2.17 2.475v4.338H9.031v-3.959c0-.671-.33-1.001-.85-1.001-.61 0-1.015.393-1.015 1.116v3.844H4.92v-3.959c0-.671-.33-1.001-.85-1.001-.609 0-1.015.393-1.015 1.116v3.844H.784zm16.241 3.362v-.101c0-1.117-.443-1.739-1.306-1.739-.85 0-1.32.597-1.32 1.713v.101c0 1.143.444 1.765 1.32 1.765.85 0 1.306-.636 1.306-1.74m-4.948.039v-.101c0-2.132 1.587-3.477 3.642-3.477 2.043 0 3.616 1.306 3.616 3.413v.101c0 2.158-1.586 3.452-3.629 3.452-2.042 0-3.629-1.243-3.629-3.388m8.26 1.104v-2.956h-.799V12.97h.8v-.467l2.271-.916v1.383h1.307v1.548h-1.307v2.74c0 .483.24.699.672.699.254 0 .444-.038.647-.114v1.724a4.73 4.73 0 0 1-1.256.19c-1.497 0-2.335-.723-2.335-2.283m4.51-6.757l2.27-.926v4.244c.356-.685 1.08-1.243 2.184-1.243 1.28 0 2.17.799 2.17 2.5v4.313h-2.272v-3.857c0-.748-.292-1.116-.952-1.116-.672 0-1.13.406-1.13 1.256v3.717h-2.27zm12.143 4.816c-.039-.8-.432-1.244-1.168-1.244-.685 0-1.154.444-1.269 1.244zm-4.759.837v-.101c0-2.132 1.586-3.477 3.59-3.477 1.815 0 3.377 1.04 3.377 3.426v.596h-4.67c.064.875.571 1.384 1.383 1.384.749 0 1.066-.343 1.155-.788h2.132c-.204 1.498-1.359 2.348-3.363 2.348-2.081 0-3.604-1.218-3.604-3.388zm7.833-3.4h2.271v1.319c.419-.99 1.116-1.422 2.144-1.407V15c-1.383-.038-2.144.393-2.144 1.458v3.147h-2.271zm4.772 4.53h2.093c.077.482.292.748.94.748.558 0 .811-.216.811-.545 0-.318-.317-.47-1.23-.597-1.776-.228-2.526-.749-2.526-2.131 0-1.473 1.308-2.183 2.843-2.183 1.637 0 2.778.558 2.931 2.145h-2.056c-.089-.445-.33-.66-.85-.66-.495 0-.749.215-.749.52 0 .317.305.444 1.117.545 1.84.229 2.728.71 2.728 2.132 0 1.573-1.167 2.284-3.007 2.284-1.89 0-2.995-.788-3.045-2.259m11.413-1.167v-.101c0-1.117-.444-1.739-1.307-1.739-.85 0-1.319.597-1.319 1.713v.101c0 1.143.444 1.765 1.32 1.765.85 0 1.306-.636 1.306-1.74m-4.949.039v-.101c0-2.132 1.586-3.477 3.642-3.477 2.043 0 3.616 1.306 3.616 3.413v.101c0 2.158-1.586 3.452-3.629 3.452S51.3 18.515 51.3 16.37m8.066-3.4h2.272v1.065c.355-.685 1.078-1.243 2.182-1.243 1.282 0 2.17.799 2.17 2.5v4.313h-2.27v-3.857c0-.748-.292-1.116-.952-1.116-.672 0-1.13.406-1.13 1.256v3.717h-2.27z" fill="currentColor" fill-rule="evenodd"></path></svg></span>
        </div>
      </div>

      {/* ================= HISTORY MODAL ================= */}
      <Modal
        open={historyOpen}
        onClose={() => setHistoryOpen(false)}
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box sx={{ bgcolor: "#303030", p: 3, borderRadius: 2, width: 600 }}>
          <Typography variant="h6" gutterBottom>
            Process History
          </Typography>

          <TableContainer component={Paper}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>S.No</TableCell>
                  <TableCell>File Name</TableCell>
                  <TableCell>Date</TableCell>
                  <TableCell align="center">Download</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>1</TableCell>
                  <TableCell>Report.xlsx</TableCell>
                  <TableCell>27-02-2026</TableCell>
                  <TableCell align="center">
                    <IconButton color="success">
                      <DownloadIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>

      {/* ================= SUCCESS MODAL ================= */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box sx={{ bgcolor: "#303030", p: 4, borderRadius: 2, width: 400 }}>
          <Typography variant="h6" align="center">
            Process Run Successfully!
          </Typography>
        </Box>
      </Modal>

      {/* ================= ERROR MODAL ================= */}
      <Modal
        open={errorModalOpen}
        onClose={() => setErrorModalOpen(false)}
        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Box sx={{ bgcolor: "#303030", p: 4, borderRadius: 2, width: 400 }}>
          <Typography variant="h6" align="center" color="error">
            Something Went Wrong!
          </Typography>
        </Box>
      </Modal>

      <React.Fragment key="right">
        <Drawer className="drawer-panel"
          anchor="right"
          open={state["right"]}
          onClose={toggleDrawer("right", false)}>
          {list("right")}
        </Drawer>
      </React.Fragment>
    </div>
  );
}




export default Hazard_Detection;